




import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
  Breadcrumbs,
  Autocomplete,
  useMediaQuery,
  InputAdornment,
  Link, Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Reasontypedata, sampleData } from "../../components/grid/GridData";
import externaldeletecomApi, { externalgetApi, externalpostApi } from "../../services/externalApis";
import { SETTING_API_01, SETTING_API_03, SETTING_API_09, SETTING_API_16, SETTING_API_17 } from "../../api/ApiModel";
import ViewDataGrid from "../../components/grid/ViewDataGrid";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import SystemAlert from "../../components/common/SystemAlert";

function ViewReason() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state) => state.user) || {};
  const {    LOCCODE,STAFFMAPLOCODE,COMPCODE,USERNAME } = SYS_USER.USER_PARAM || {};
  const [isLoading, setIsLoading] = useState(false);
 const [datadoccat, setDatadoccat] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
   const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
    const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
    const [alertMessage, setAlertMessage] = useState("");
    const [statusFilter, setStatusFilter] = useState("A"); // Default "Enable"
const [openDisableDialog, setOpenDisableDialog] = useState(false);
const [disableTargetId, setDisableTargetId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);


    const [selectedreasoncatcode, setSelectedreasoncatcode] = useState("");
  useEffect(() => {
    setPageData({ title: "Reason Types" });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedreasoncatcode) return;
      try {
        const result = await externalgetApi(SETTING_API_17, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          reasoncatcode: selectedreasoncatcode,
          STS: statusFilter,
        });
        setData(result);
        setFilteredRows(result);
        console.log("Fetched data:", result);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [selectedreasoncatcode, statusFilter]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_16, "get", { STS: CON_STATUS_ACTIVE });
        setDatadoccat(result);
        console.log("Fetched doccat data:", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(datadoccat) && datadoccat.length > 0) {
      setSelectedreasoncatcode(datadoccat[0].reasoncatcode);
    }
  }, [datadoccat]);

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.reasontypecode === id);
      const selectedCategory = datadoccat?.find((item) => item.reasoncatcode === selectedItem?.reasoncatcode);
      if (selectedItem) {
        navigate(`/CreatreReason`, {
          state: {
            selectedItem,
            actionText,
            selectedreasoncatcode: selectedCategory?.reasoncatcode || "",
            selectedreasoncatname: selectedCategory?.reasoncatname || "",
          },
        });
      }
    }
  };

  const openDisableConfirmation = (reasontypecode) => {
    setDisableTargetId(reasontypecode);
    setOpenDisableDialog(true);
  };

  const cancelDisable = () => {
    setOpenDisableDialog(false);
    setDisableTargetId(null);
  };

  const confirmDisable = () => {
    if (disableTargetId) handleDisable(disableTargetId);
    cancelDisable();
  };

  const handleEnable = async (reasontypecode) => {
    const selectedItem = data.find((item) => item.reasontypecode === reasontypecode);
    if (!selectedItem) return;
    const payload = {
      reasontypecode: selectedItem.reasontypecode,
      reasoncatcode: selectedItem.reasoncatcode,
      compcode: COMPCODE,
      loccode: STAFFMAPLOCODE,
      descrip: selectedItem.descrip,
      sts: "A",
      enuser: USERNAME,
    };
    await externalpostApi(SETTING_API_17, payload);
    setAlertMessage("Enabled successfully.");
    setAlertType("success");
    setAlertOpen(true);
    const refreshedData = await externalgetApi(SETTING_API_17, "get", {
      COMPCODE,
      LOCCODE: STAFFMAPLOCODE,
      reasoncatcode: selectedreasoncatcode,
      STS: statusFilter,
    });
    setData(refreshedData);
    setFilteredRows(refreshedData);
  };

  const handleDisable = async (reasontypecode) => {
    const selectedItem = data.find((item) => item.reasontypecode === reasontypecode);
    if (!selectedItem) return;
    // const payload = {
    //   reasontypecode: selectedItem.reasontypecode,
    //   reasoncatcode: selectedItem.reasoncatcode,
    //   compcode: COMPCODE,
    //   loccode: STAFFMAPLOCODE,
    //   descrip: selectedItem.descrip,
    //   sts: "D",
    //   enuser: USERNAME,
    // };
    // await externalpostApi(SETTING_API_17, payload);
    await externaldeletecomApi(`Reasontype/${selectedItem.reasontypecode}`, {
            BREASONTYPECODE: String(selectedItem.reasontypecode),
            ENUSER: USERNAME || "ss",
            sts: "D",
          });
    
    setAlertMessage("Disabled successfully.");
    setAlertType("warning");
    setAlertOpen(true);
    const refreshedData = await externalgetApi(SETTING_API_17, "get", {
      COMPCODE,
      LOCCODE: STAFFMAPLOCODE,
      reasoncatcode: selectedreasoncatcode,
      STS: CON_STATUS_ACTIVE,
    });
    setData(refreshedData);
    setFilteredRows(refreshedData);
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    const filtered = Array.isArray(data)
      ? data.filter((row) => (row.descrip || "").toLowerCase().includes((value || "").toLowerCase()))
      : [];
    setFilteredRows(filtered);
  };

  const addToView = () => {
    const selectedCategory = datadoccat?.find((item) => item.reasoncatcode === selectedreasoncatcode);
    navigate("/CreatreReason", {
      state: {
        selectedreasoncatcode: selectedCategory?.reasoncatcode || "",
        selectedreasoncatname: selectedCategory?.reasoncatname || "",
        actionText: "Add",
      },
    });
  };

  const menuItems = statusFilter === "A"
    ? [
        { text: "Edit", icon: <BorderColorOutlinedIcon />, onClick: (id) => handleItemClick(id, "Edit") },
        { text: "Disable", icon: <CommentsDisabledIcon />, onClick: openDisableConfirmation },
      ]
    : [
        { text: "Enable", icon: <BorderColorOutlinedIcon />, onClick: handleEnable },
      ];


  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
     <Breadcrumbs
                 separator="›"
                 aria-label="breadcrumb"
                 sx={styles.breadcrumb}
               >
                 <Link
                   underline="hover"
                   sx={styles.breadcrumb_link}
                   // href=""
                 >
                   Home
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link}
                   underline="hover"
                   // href=""
                 >
                   Settings
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link_page}
                   underline="hover"
                   // href="#"
                   aria-current="page"
                 >
               
            Reason Types
                 </Link>
               </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 8 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {Reasontypedata.name}
              </Typography>
            </Grid>

            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 8, xl: 4 }}
              sx={styles.appbar_grid_search}
            >



<Autocomplete
  options={Array.isArray(datadoccat) ? datadoccat : []} // Ensure datadoccat is an array
  getOptionLabel={(option) => option.reasoncatname || ""} // Use doccatname or fallback to an empty string
  disableClearable
  fullWidth
  value={
    Array.isArray(datadoccat)
      ? datadoccat.find((item) => item.reasoncatcode === selectedreasoncatcode) || null
      : null
  } // Match the selected value or fallback to null
  onChange={(event, newValue) => {
    const reasoncatcode = newValue ? newValue.reasoncatcode : "";
    console.log("Selected reasoncatcode:", reasoncatcode);
    setSelectedreasoncatcode(reasoncatcode);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label={
        <span>
          Reason Category Name<span style={{ color: "red" }}> *</span>
        </span>
      }
      variant="outlined"
      error={!!error?.reasoncatcode} // Show error if reasoncatcode has an issue
      helperText={error?.reasoncatcode} // Display helper text for the error
      size="small"
      name="reasoncatcode"
    />
  )}
  ListboxProps={{
    style: {
      maxHeight: 150,
      backgroundColor: theme.palette.background.paper,
    },
  }}
/>

<Autocomplete
  options={[
    { label: "Enabled", value: "A" },
    { label: "Disabled", value: "D" },
  ]}
  getOptionLabel={(option) => option.label}
  disableClearable
  fullWidth
  value={{ label: statusFilter === "A" ? "Enabled" : "Disabled", value: statusFilter }}
  onChange={(event, newValue) => {
    setStatusFilter(newValue.value);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Status"
      variant="outlined"
      size="small"
    />
  )}
  ListboxProps={{
    style: {
      maxHeight: 150,
      backgroundColor: theme.palette.background.paper,
    },
  }}
/>


<Autocomplete
  freeSolo
  id="sample-search"
  fullWidth
  disableClearable
  value={searchQuery}
  onInputChange={handleSearchChange} // Handles typing
  onChange={handleSearchChange}      // Handles selection
  sx={styles.ipt_appbar_search_auto}
  options={data?.map((row) => row.descrip) || []}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Search by..."
      size="small"
      sx={styles.ipt_appbar_search}
      InputProps={{
        ...params.InputProps,
        type: "search",
        endAdornment: (
          <InputAdornment position="end">
            <IconButton sx={styles.btn_appbar_search_icon}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )}
/>

      


              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToView}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </AppBar>

        <Box sx={styles.view_page_container}>
        <ViewDataGrid
  columns={Reasontypedata.columns}
 
  rows={filteredRows.map((row) => ({
    ...row,
    id: row.reasontypecode || Math.random(), // Ensure each row has a unique id
  }))}
  getRowId={(row) => row.id} // Use the id property for unique identification
  isLoading={isLoading}
  menuItems={menuItems}
  tabletitle={Reasontypedata.name}
  gridid="reasontypecode"
  sx={styles.view_data_grid_page}
/>
        </Box>

          <SystemAlert
                  open={alertOpen}
                  type={alertType}
                  message={alertMessage}
                  onClose={() => setAlertOpen(false)}
                />

                   <SystemAlert open={alertOpen} type={alertType} message={alertMessage} onClose={() => setAlertOpen(false)} />

        {/* Disable Confirmation Dialog */}
        <Dialog open={openDisableDialog} onClose={cancelDisable} aria-labelledby="disable-dialog-title">
          <DialogTitle id="disable-dialog-title">Confirm Disable</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to disable this reason type?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelDisable} sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }} color="inherit">Cancel</Button>
            <Button onClick={confirmDisable} color="error" sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }} variant="contained">Disable</Button>
          </DialogActions>
        </Dialog>

      </Box>
    </>
  );
}
export default ViewReason;
